/* src/app/ship/ship-to/ship-to-edit/ship-to-edit.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ship-to-edit {
  width: 100%;
  font-size: 1rem;
}
.ship-to-edit.ups-form > .form-body {
  padding: 0;
}
.ship-to-edit .select-wrapper {
  position: relative;
}
.ship-to-edit .mat-mdc-checkbox {
  display: block;
}
.ship-to-edit .email-notifications {
  padding-bottom: 1em;
  margin-bottom: 1.5em;
  border-bottom: solid thin #f0f0ef;
}
.ship-to-edit .parcel-pro-notification .custom-email-options {
  padding: 1.75em 1.75em 1.125em 1.75em;
  border: solid thin #d9d9d6;
  box-shadow: 0 1px 1px 0 rgba(217, 217, 214, 0.5);
  border-radius: 8px;
  margin-top: 1em;
}
.ship-to-edit .parcel-pro-notification .custom-email-options ::ng-deep .mat-mdc-form-field {
  font-size: 0.8125rem;
}
.ship-to-edit .parcel-pro-notification .parcel-pro-notify-upload-photo .message {
  font-size: 0.8125em;
  letter-spacing: 0.5px;
  line-height: 1.25;
}
.ship-to-edit .parcel-pro-notification .parcel-pro-notify-upload-photo .actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.125rem;
}
.ship-to-edit .parcel-pro-notification .parcel-pro-notify-upload-photo .actions .mat-mdc-raised-button {
  font-size: 0.8125rem;
  border-radius: 3px;
}
/*# sourceMappingURL=ship-to-edit.component.css.map */
